/**
 * Cấu hình khóa Local Storage cho lưu trữ dữ liệu.
 * Yêu cầu:
 *  - Cần đặt tên khóa đúng cú pháp để tránh sự trùng lặp tên khóa.
 *  - Cần viết mô tả cho khóa đã khai báo:
 *    vd: // Khóa lưu trữ <Nội dung thông tin> trong chức năng <Tên chức năng>
 *  - Cần quy hoạch khóa dựa theo chức năng (feature) hoặc toàn ứng dung (global):
 *  - Xem mẫu ở dưới nhé!!!
 * */
export const LocalStorageConfigKeys = {
  global: {
    transloco: {
      // Khóa lưu trữ ngôn ngữ hiện tại của Transloco.
      currentLanguage: 'global.transloco.currentLangulage',
    },
    layouts: {
      themeSetting: 'global.layouts.themeSetting',
      currentThemeMode: 'global.layouts.currentThemeMode'
    },
    routing: {
      // Khóa lưu trữ URL trước đó trong định tuyến sau khi login thành công.
      previousUrl: 'global.routing.previousUrl',
      devPreviousUrl: 'global.routing.devPreviousUrl',
    },
  },
  feature: {
    /**
     * Localstorage luu cac key phuc vu module tuyen sinh cap dong phuc
     */
    tuyenSinhCapDongPhuc: {
      caiDat: {
        chung: {
          canBoXuLy: 'features.tuyenSinhCapDongPhuc.caiDat.chung.canBoXuLy',
          ngay: 'features.tuyenSinhCapDongPhuc.caiDat.chung.ngay',
          campus: 'features.tuyenSinhCapDongPhuc.caiDat.chung.campus',
        }
      }
    }
  },
};
